import { all } from 'redux-saga/effects';
import getUserSaga from './getUserSaga';

export default all([getUserSaga()]);
